import { ReactNode, useMemo } from "react";
import HttpClientProvider, { useHttpClient } from "../../../../shared/http/HttpClientProvider";
import { useOidcUser } from "../../auth/components/OidcUserProvider";
import { useBrandAuthConfig } from "../../configuration/components/BrandAuthConfigProvider";
import { useApiServerInfo } from "../../discovery/ApiServerInfoProvider";
import { useSession } from "../../session/SessionProvider";
import { getBearerAuthHeader,  getRestApiBaseUrlWithSessionId } from "../utils/utils";

interface Props {
    children?: ReactNode;
}

function SessionInterceptor(props: Props) {
    const brandAuthConfig = useBrandAuthConfig();
    const apiServerInfo = useApiServerInfo();
    const session = useSession();
    const oidcUser = useOidcUser();
    const http = useHttpClient();

    const _httpClient = useMemo(() => {
        const _http = http.clone();

        _http.addRequestInterceptor(config => {
            config.baseURL = getRestApiBaseUrlWithSessionId(brandAuthConfig, apiServerInfo, session.value.sessionId);

            const headers = config.headers || {};
            headers['Authorization'] = getBearerAuthHeader(oidcUser.value!)
            config.headers = headers;

            return config;
        });

        return _http;
    }, [http, brandAuthConfig, oidcUser, apiServerInfo, session])

    return (
        <HttpClientProvider httpClient={_httpClient}>
            {props.children}
        </HttpClientProvider>
    )
}

export default SessionInterceptor;